/**
 * Backend `htsVerificationSource` on a line item (#13383). `None` = the line still needs classification.
 * "Validated" sources: 1–5 and 7. `AssistantNoAnswer` (6) passes the send/pay gate but is not "validated".
 */
export enum enumHtsVerificationSource {
  None = 0,
  Assistant = 1,
  Catalog = 2,
  CompanyHistory = 3,
  PartNumberMapping = 4,
  Broker = 5,
  /** The assistant could not determine a code; the user may type one by hand afterwards (the broker checks it). */
  AssistantNoAnswer = 6,
  /** The user confirmed a code suggested from a similar product the company already classified (#13517). */
  SimilarityConfirmed = 7,
}
